import store from "./store"

import Vue from 'vue';

export const EventBus = new Vue();


let Utils = {
    
    
    downLoadPDFNewTab(response){
        let blob = new Blob([response.data], {
            type: "application/pdf"
        });
        
        const binaryString = atob(response.headers['filename']);
        
        // Convert binary string to UTF-8 text
        const decodedFileName = decodeURIComponent(escape(binaryString));
        
        let url = window.URL.createObjectURL(blob);
        
        window.open(url,"decodedErrorMessage")
        
        // Create a temporary anchor element
        let a = document.createElement('a');
        a.href = url;
        console.log(decodedFileName);
        a.download = decodedFileName;  // Set the correct filename here
        
        // Append to the body and trigger the download
        document.body.appendChild(a);
        a.click();
        
        // Clean up and revoke the object URL
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    },
    
    
    returnStatementBookCourrierStatusText(item){
        if(item !== undefined && item != null && item.hasOwnProperty('status')){
            
            if(item.status.status ==='INSERTED'){
                return 'Εν αναμονή έναρξης αποστολής από τον εκδότη';
            }else if(item.status.status ==='GOT_VOUCHER'){
                return 'Σε στάδιο προετοιμασίας αποστολής, με Κωδικό Voucher: '+ item.voucherNo + '. <br/> Μπορείτε να ενημερωθείτε για την πορεία της αποστολής  <a href="https://www.elta-courier.gr/search" target="_blank"><i>εδώ</i></a>';
            }else if(item.status.status ==='PICKED_UP'){
                return 'Παραλήφθηκε από courier. Κωδικός Voucher: '+ item.voucherNo + '. <br/> Μπορείτε να ενημερωθείτε για την πορεία της αποστολής  <a href="https://www.elta-courier.gr/search" target="_blank"><i>εδώ</i></a>';
            }else if(item.status.status ==='DELIVERED'){
                return 'Στην κατοχή του φοιτητή. Κωδικός Voucher: '+ item.voucherNo + '. <br/> Μπορείτε να δείτε αναλυτικά το Ιστορικό της αποστολής  <a href="https://www.elta-courier.gr/search" target="_blank"><i>εδώ</i></a>';
            }else if(item.status.status ==='RETURNED'){
                return 'Επιστράφηκε στον Εκδότη, Κωδικός Voucher: '+ item.voucherNo + '. <br/> Μπορείτε να δείτε αναλυτικά το Ιστορικό της αποστολής  <a href="https://www.elta-courier.gr/search" target="_blank"><i>εδώ</i></a>';
            }else if(item.status.status ==='CANCELED'){
                return 'Ακυρώθηκε! Επικοινωνήστε με τον Εκδότη.';
            }
        }
    },

    redeemPointsById(checkedBooks, redeemPoints) {
        var avaliableCredit = store.getters.avaliableCredit;

        for (var book in checkedBooks) {
            if (redeemPoints.hasOwnProperty(checkedBooks[book].books.books[0].book.id)) {
                if (!redeemPoints[checkedBooks[book].books.books[0].book.id].books.books[0].book.price) {
                    avaliableCredit = Math.round((avaliableCredit - parseFloat(redeemPoints[checkedBooks[book].books.books[0].book.id].books.books[0].book.suggestedPrice)) * 100) / 100;
                    store.commit('setAvaliableCredit', avaliableCredit);
                } else {
                    avaliableCredit = Math.round((avaliableCredit - parseFloat(redeemPoints[checkedBooks[book].books.books[0].book.id].books.books[0].book.price)) * 100) / 100;
                    store.commit('setAvaliableCredit', avaliableCredit);
                }
                delete redeemPoints[checkedBooks[book].books.books[0].book.id]
            }
        }
        return redeemPoints;
    },

    existsCheckedBooks(courseId, bookId) {
        var checkedBooks = store.getters.checkedBooks;
        if ((courseId in checkedBooks)) {
            if (checkedBooks[courseId].books.books[0].book.id == bookId) {
                return true
            } else
                return false
        }
    },

    containsPathToBook(path) {
        if (path !== undefined && path.substring(0, 4) !== 'http') {
            return 'https://static.eudoxus.gr/books/' + path
        } else {
            return path
        }
    },

    // Tooltips
    tooltipCreate_EXPIRED(book) {
        return book.delivered === false &&
            book.status.status === "EXPIRED";
    },
    tooltipCreate_DELIVERED_FALSE(book) {
        return book.wronglyDelivered === false &&
            book.status.status === "DELIVERED";
    },
    tooltipCreate_DELIVERED(book) {
        return book.wronglyDelivered === true &&
            book.status.status === "DELIVERED";
    },
    tooltipCreate_IN_LIBRARY(book) {
        return (book.wronglyDelivered === true &&
            book.status.status === "IN_LIBRARY");
    },
    tooltipCreate_RETURNED_IN_DP(book) {
        return book.delivered === false &&
            book.status.status === "RETURNED";
    },
    tooltipCreate_EXCHANGED(book) {
        return book.delivered === true &&
            book.status.status === "EXCHANGED";
    },
    tooltipGotVoucherOrPicked_up(book) {
        return book.status.status === "GOT_VOUCHER" || book.status.status === "PICKED_UP"
    },
    tooltipMsg(id, item) {
        let semester;
        if (item.period === "Ximerino") {
            semester = "Χειμερινό"
        } else if (item.period === "Earino") {
            semester = "Εαρινό"
        }
        if (id === 1) {
            return "Ληξιπρόθεσμο, δεν παραλήφθηκε απο φοιτητή " + item.books.course.year + " " + semester + " " + item.date
        } else if (id === 2) {
            return "Το σύγγραμμα το έχετε παραλάβει " + item.books.course.year + " " + semester + " " + item.date
        } else if (id === 3) {
            return "Το σύγγραμμα το έχετε παραλάβει χωρίς να το δικαιούστε " + item.books.course.year + " " + semester + " " + item.date
        } else if (id === 4) {
            return "Το σύγγραμμα επιστράφηκε στη βιβλιοθήκη " + item.books.course.year + " " + semester + " " + item.date
        } else if (id === 5) {
            return "Το σύγγραμμα επιστράφηκε στο σημείο διανομής " + item.books.course.year + " " + semester + " " + item.date
        } else if (id === 6) {
            return "Έχετε παραλάβει το σύγγραμμα και το ανταλλάξατε " + item.books.course.year + " " + semester + " " + item.date
        } else if (id === 7) {
            return "Προετοιμασία για αποστολή από τον Εκδότη. Δήλωση: " + item.books.course.year + " " + semester + " " + item.date
        } else {
            return ""
        }
    },

    checkIfBookIsNotExpired(code, title) {

        var courseCodeHashMap = store.getters.courseCodeHashMap;
        if (courseCodeHashMap.hasOwnProperty(code)) {
            if (courseCodeHashMap[code].title == title) {
                return true;
            }
        }
        return false;

    },
    
    checkIfStudentHasBookFromPreviousStatements(book){
        // https://gitlab.grnet.gr/eudoxus/StudentApp2-FrontEnd/-/issues/33 -> Student_9
        // I have no idea on how it works so I follow the flow of the tooltip Component and its functions
        if(this.checkToolTipId(book.id)){
            
            // this means it has tooltip component
            // util.tooltipCreate_DELIVERED_FALSE()  is matched with util.tooltipMsg(2,..) which is the message -> Το σύγγραμμα το έχετε παραλάβει " + item.books.course.year + " " + semester + " " + item.date
            // this.$store.getters.tooltipBookId[book.id].book this will give statementbook data required for the util call.
            return this.tooltipCreate_DELIVERED_FALSE(store.getters.tooltipBookId[book.id].book);
        } else{
            return false; //we don't want the radio button disabled in this case
        }
        
    },

    checkToolTipId(bookId) {
        var toolTipId = store.getters.tooltipBookId;
        return toolTipId.hasOwnProperty(bookId);
    },

    checkBooksLength() {
        return Object.keys(store.getters.checkedBooks).length > 0;
    },

    redeemPointsLength() {
        return Object.keys(store.getters.redeemPoints).length > 0;
    },

    // Check if Student is more than N+2 years or he is Katataktirios
    isNPlus2OrKatataktirios() {
        let login = store.getters.login;
        if (login.borrowed != null) {
            var borrowed = login.borrowed
        }
        return borrowed || this.isKatataktirios(login)

    },
    isKatataktirios(login) {
        if (login.inArrangementsBlackListByStatement != null) {
            var inArrangementsBlackListByStatement = login.inArrangementsBlackListByStatement;
        }
        if (login.inArrangementsBlackListByInstitution != null) {
            var inArrangementsBlackListByInstitution = login.inArrangementsBlackListByInstitution
        }
        return inArrangementsBlackListByStatement || inArrangementsBlackListByInstitution
    },

    // Splits the allBooks array in 3 arrays depending on the availability
    setBookArraysByDistType(allBooks, isFromChecked) {

        // var courrierVisibilityFlag = store.getters.courierInfoFlag;

        if (Object.keys(allBooks).length < 1) {
            if (isFromChecked == true) {
                store.commit('setBooksFromCheckedByDistPoint', []);
                store.commit('setBooksFromCheckedByCourrier', []);
            } else {
                store.commit('setBooksFromRedeemByDistPoint', []);
                store.commit('setBooksFromRedeemByCourrier', []);
            }
        } else {
            //Secretariat or DistributionPoint or Courier
            var booksByDistPoint = [];
            var booksByCourier = [];


            var allPoints = store.getters.points;

            for (let courseId in allBooks) {
                var book = allBooks[courseId].books.books[0].book;
                var finalBookItem = {};

                // If not exist in Points then is For Courier
                if (!(book.id in allPoints)) {
                    finalBookItem.book = allBooks[courseId];
                    booksByCourier.push(finalBookItem);
                    continue;
                }


                if (book.id in allPoints) {
                    // Every book may have many points
                    var pointArray = allPoints[book.id];

                    // Count both to compare stocks
                    var countDistPoint = 0;
                    var countSecretariat = 0;

                    // Create points to show at last
                    var distPoints = [];
                    var secretariatPoints = [];

                    for (var i = 0; i < pointArray.length; i++) {
                        var point = pointArray[i];

                        // Add all DistPoints to the List and show all even if some have availability
                        if (point.distributionPoint.distributionPointType == "DistributionPoint") {
                            distPoints.push(point);
                            countDistPoint++;
                        }

                        // If Secretariat has availability the add to the List
                        if (point.distributionPoint.distributionPointType == "Secretariat") {
                            if (point.availability > 0) {
                                countSecretariat += point.availability;
                                secretariatPoints.push(point);
                            }
                        }
                    }

                    // If no DistributionType exist
                    // if (countDistPoint < 1)
                    //     // Set Courrier button Visibility to VISIBLE
                    //     courrierVisibilityFlag =  true;

                    // If Secretariat has stock the override everything
                    if (countSecretariat > 0) {
                        finalBookItem.book = allBooks[courseId];
                        finalBookItem.points = secretariatPoints;
                        booksByDistPoint.push(finalBookItem);

                    } else if (countDistPoint > 0) {
                        finalBookItem.book = allBooks[courseId];
                        finalBookItem.points = distPoints;
                        booksByDistPoint.push(finalBookItem);

                    } else {
                        finalBookItem.book = allBooks[courseId];
                        booksByCourier.push(finalBookItem);
                    }
                }
            }

            // If called for checkedBooks
            if (isFromChecked) {
                store.commit('setBooksFromCheckedByDistPoint', booksByDistPoint);
                store.commit('setBooksFromCheckedByCourrier', booksByCourier);
            }

            // If called for redeemBooks
            else {
                store.commit('setBooksFromRedeemByDistPoint', booksByDistPoint);
                store.commit('setBooksFromRedeemByCourrier', booksByCourier);
            }


            // If CourrierButton visibility Flag has already Set to true
            // if (store.getters.courierInfoFlag) {
            //     if (store.getters.booksFromCheckedByCourrier.length < 1 && store.getters.booksFromRedeemByCourrier.length < 1) {
            //         this.checkCourierInfoFlag(booksByCourier, courrierVisibilityFlag);
            //     }
            // }
            // else {
            //     this.checkCourierInfoFlag(booksByCourier, courrierVisibilityFlag)
            // }
        }


    },

    // Setup visibility Courrier button
    setCourrierVisibilityButton(allPoints) {
        var checkedBooks = store.getters.checkedBooks;
        var redeemPoints = store.getters.redeemPoints;
        var allBookIds = [];

        if (Object.keys(checkedBooks).length == 0 && Object.keys(redeemPoints).length == 0)
            return false;

        var hasDistributionPoint = false;
        var showCourrierButton = false;

        for (var checkedBook in checkedBooks) {
            allBookIds.push(checkedBooks[checkedBook].books.books[0].book.id)
        }

        for (var redeemPoint in redeemPoints) {
            allBookIds.push(redeemPoints[redeemPoint].books.books[0].book.id)
        }


        for (var i = 0; i < allBookIds.length; i++) {
            hasDistributionPoint = false;
            for (var allPoint in allPoints) {
                if (allPoint == allBookIds[i]) {
                    for (var j = 0; j < allPoints[allPoint].length; j++) {
                        if (allPoints[allPoint][j].distributionPoint.distributionPointType == 'DistributionPoint') {
                            hasDistributionPoint = true;
                        }
                    }
                }
            }

            if (!hasDistributionPoint) {
                showCourrierButton = true;
                break;
            }
        }

        return showCourrierButton;
    },

    // Setup Visibility of CourierBtn and Disabled of FinalDeclarationBtn
    checkCourierInfoFlag(points) {

        // Check if this period allows newStatement or updateStatement
        if (store.getters.newStatementAllow === true) {

            if (this.setCourrierVisibilityButton(points)) {
                store.commit('setCourierInfoFlag', true);

                if (Object.entries(store.getters.courier).length > 0) {
                    store.commit('setFinalDeclarationflag', true);
                } else {
                    store.commit('setFinalDeclarationflag', false);
                }

            } else {
                store.commit('setCourierInfoFlag', false);
                store.commit('setFinalDeclarationflag', true)
            }

        } else {
            if (this.setCourrierVisibilityButton(points)) {
                store.commit('setCourierInfoFlag', true);
            }else{
                store.commit('setCourierInfoFlag', false);
            }
            store.commit('setFinalDeclarationflag', false)
        }
    },

    // Get Semesters  numbers from active/secretariatId sorted
    getSemestersFromActive(courses, statementMaxCourseSemester) {
        var j = 0;
        var semesterArray = [];

        for (var i = 0; i < courses.length; i++) {
            if (!semesterArray.includes(courses[i].semester)) {

                // if statementMaxCourseSemester == 1 we ignore the Max Semester that Student is allowed to see
                if (statementMaxCourseSemester != -1) {
                    if (Number(courses[i].semester) <= Number(statementMaxCourseSemester)) {
                        semesterArray[j] = courses[i].semester;
                        j++
                    }
                } else {
                    semesterArray[j] = courses[i].semester;
                    j++
                }
            }
        }

        return semesterArray.sort((a,b) => a - b);
    },

    // Create SemesterData array with given semesterCourses
    getSemesterData(bookGroups, semesterCoursesArray, checkedBooks, secretariatId) {

        var semesterData = [];

        // Looping in All Courses per Semester
        for (var i = 0; i < semesterCoursesArray.length; i++) {

            var courseObject = [];
            var courses = semesterCoursesArray[i].courses;

            // Courses of "i" Semester
            for (var j = 0; j < courses.length; j++) {

                // Array to push all the books of specific Course
                var courseBooks = [];
                var courseInfo = null;
                var bookExistsInChecked = false;
                var bookId = null;

                for (var z = 0; z < bookGroups.length; z++) {

                    // If this book belongs to the current Course
                    if (bookGroups[z].courseId == courses[j].id && bookGroups[z].active === true) {
                        if(bookGroups[z]['statementBookGroupType'] == null ){
                            bookGroups[z]['statementBookGroupType'] = 'NORMAL';
                        }
                        courseInfo = bookGroups[z].course;
                        courseBooks.push(bookGroups[z]);

                        // If checkBooks == null mean we call the function from newStatement
                        if (checkedBooks != null)
                            if (checkedBooks[bookGroups[z].courseId] !== undefined && checkedBooks[bookGroups[z].courseId].books.course.secretariatID == secretariatId) {
                                bookId = checkedBooks[bookGroups[z].courseId].books.books[0].book.id;
                                bookExistsInChecked = true;
                            }
                    }
                }


                if (courseInfo == null) {
                    courseInfo = courses[j];
                }

                courseObject.push({
                    courseIno: courseInfo,
                    courseBooks: courseBooks.sort((bookA, bookB) => (bookA.position < bookB.position) ? -1 : 1),
                    visibilityFlag: bookExistsInChecked,
                    radioValue: bookId,
                    courseRegistration: false
                });
            }
            semesterData.push({semester: semesterCoursesArray[i].semester, semesterInfo: courseObject, courseRegistration: false});
        }
        return semesterData;
    },

    createSemesterCoursesArray(courses, semester) {

        var semesterCoursesArray = [];

        for (var i = 0; i < semester.length; i++) {
            var semesterCourses = [];
            var curetntSemester = semester[i];

            for (let j = 0; j < courses.length; j++) {
                var courseItem = courses[j];
                if (courseItem.semester == semester[i])
                    semesterCourses.push(courseItem);
            }
            semesterCoursesArray.push({semester: curetntSemester, courses: semesterCourses});
        }
        return semesterCoursesArray;
    },

    setCounterExchangeBooks() {

        var books = store.getters.listForExchange;
        var counterReturnedToLibrary = 0;
        var counterPassedToStudent = 0;
        var counterExchangable = 0;
        var counterDelivered = 0;
        var wronglyDelivered = 0;
        // store.commit('setCounterDelivered', books.length);
        for (let i = 0; i < books.length; i++) {
            if(books[i].wronglyDelivered){
                wronglyDelivered++;
            }
            
            if (books[i].delivered) {
                if(books[i].deliveredFromStatement){
                    counterDelivered++;
                }
                // this.counterDelivered++;
                if (books[i].type == "Published" && !books[i].exchangable) {

                } else if (books[i].type == "Published" &&
                    books[i].exchangable && books[i].exchangeDestinationId == null) {
                    counterExchangable++
                } else if (books[i].type == "Published" &&
                    books[i].exchangable && books[i].exchangeDestinationId != null) {
                    counterExchangable++
                } else if (books[i].type == "ePublished") {

                }
            }
            if (books[i].libraryId != null) {
                counterReturnedToLibrary++;
            }
            if (books[i].exchangeDestinationCredits != null ) {
                counterPassedToStudent++;
            }

        }
        store.commit('setCounterDelivered', counterDelivered);
        store.commit('setCounterReturnedToLibrary', counterReturnedToLibrary);
        store.commit('setCounterPassedToStudent', counterPassedToStudent);
        store.commit('setCounterExchangeable', counterExchangable);
        store.commit('setTotalWronglyDeliveredBooks', wronglyDelivered);
    },

    getCredit(book, statementBookGroupType, asDestination) {
        var bookGroupType = null;
        var credit = 0;
        if (statementBookGroupType != null) {
            bookGroupType = statementBookGroupType;
        }
        if (this.isNPlus2OrKatataktirios() && bookGroupType != "CREDIT" && asDestination) {
            return 0;
        }
        if (book.hasOwnProperty("price")) {
            credit = book.price.replace("[^\\d,.]+", "");
            credit = credit.replace(",", ".");
            credit = parseFloat(credit) * 0.3;
            credit = Math.round((credit) * 100) / 100;

        } else if (book.hasOwnProperty("suggestedPrice")) {
            credit = book.suggestedPrice.replace("[^\\d,.]+", "");
            credit = credit.replace(",", ".");
            credit = parseFloat(credit) * 0.3;
            credit = Math.round((credit) * 100) / 100;
        } else {
            credit = 20 * 0.3;
            credit = Math.round((credit) * 100) / 100;
        }
        return credit.toFixed(2)
    },
    //check if gredis is show in table ------ EudoxusExchangeComponent
    getExchangeStatusOfGreditBook(book) {
        if (book.status.status == 'DELIVERED') {
            if (book.type == 'Published') {
                if (book.finalizedByPublisher) {
                    return this.getCredit(book, null, false)
                }
            }

        }

    },

    getExchangeStatusDescription(book) {
        var dstStatementBookId = book.exchangeDestinationId != null ? book.exchangeDestinationId : null;
        if (book.status.status == 'DELIVERED') {

            if (book.type == 'Published' && !book.exchangable) {
                if (book.finalizedByPublisher) {
                    return "Μπορείτε να διαθέσετε το σύγγραμμα για ανταλλαγή"
                    // return "Μπορείτε να διαθέσετε το σύγγραμμα για ανταλλαγή. Με την παράδοση του συγγράμματος θα κερδίσετε <u class=\"red--text\">" +
                    //     this.getCredit(book, null, false) + "</u> μονάδες."
                } else {
                    return "Έχετε παραλάβει το βιβλίο. Μπορείτε να το διαθέσετε για ανταλλαγή. Με την παράδοση του βιβλίου θα προστεθούν μονάδες πίστωσης στον λογαριασμό σας."
                }
            } else if (book.type == "Published" && book.exchangable && dstStatementBookId == null) {
                return "Το σύγγραμμα έχει δηλωθεί διαθέσιμο για ανταλλαγή. Αναμένεται η επιλογή του από κάποιο φοιτητή."
            } else if (book.type == "Published" && book.exchangable && dstStatementBookId != null) {
                return "Το σύγγραμμα έχει επιλεγεί απο φοιτητή για ανταλλαγή. Πατήστε Στοιχεία Ανταλλαγής για περισσότερες πληροφορίες."
            } else if (book.type == "ePublished") {
                return "Έχετε παραλάβει το σύγγραμμα σε ηλεκτρονική μορφή (download)."
            }

        } else if (book.status.status == 'IN_LIBRARY') {
            return "Το σύγγραμμα έχει επιστραφεί σε βιβλιοθήκη"
        } else if (book.status.status == 'EXCHANGED') {
            return "Το σύγγραμμα έχει παραδοθεί σε άλλο φοιτητή"
        }
    },

    bookExistInCheckedBooks(bookId, index) {
        var booksFromCheckedByDistPoint = store.getters.booksFromCheckedByDistPoint;
        if (booksFromCheckedByDistPoint != null) {
            for (var i = 0; i < index; i++)
                if (booksFromCheckedByDistPoint[i].book.books.books[0].book.id == bookId)
                    return false
        }
        return true
    },


    // Return if given distPointId exists inside booksFromCheckedByDistPoint for given Book
    // Means that Book is available even if 0 in DistPoint
    bookExistInPoints(distPointId, bookId, booksFromCheckedOrRedeemByDistPoint) {
        // var booksFromCheckedByDistPoint = store.getters.booksFromCheckedByDistPoint;

        for (var i = 0; i < booksFromCheckedOrRedeemByDistPoint.length; i++) {
            var bookOfCurrentItem = booksFromCheckedOrRedeemByDistPoint[i].book.books.books[0].book;

            if (bookOfCurrentItem.id == bookId) {
                var pointsOfCurrentBook = booksFromCheckedOrRedeemByDistPoint[i].points;

                for (var j = 0; j < pointsOfCurrentBook.length; j++) {
                    var currentPoint = pointsOfCurrentBook[j];
                    if (currentPoint.distributionPoint.id == distPointId)
                        return true
                }
            }
        }

        return false;
    },

    searchFunction(input) {
        var out = "";
        for (var i = 0; i < input.length; i++) {
            var c = input.charAt(i);
            switch (c) {
                case "α":
                case "ά":
                    c = "[αά]";
                    break;
                case "ε":
                case "έ":
                    c = "[εέ]";
                    break;
                case "η":
                case "ή":
                    c = "[ηή]";
                    break;
                case "ι":
                case "ί":
                case "ϊ":
                case "ΐ":
                    c = "[ιίϊΐ]";
                    break;
                case "ο":
                case "ό":
                    c = "[οό]";
                    break;
                case "υ":
                case "ύ":
                case "ϋ":
                case "ΰ":
                    c = "[υύϋΰ]";
                    break;
                case "ω":
                case "ώ":
                    c = "[ωώ]";
                    break;
            }
            out += c
        }
        return out;
    },

    checkIfN2plusBooksDeliveredFalse() {

        var statement = store.getters.statement;
        var lastStatementBookGroups;
        var arrayOfBookIds = [];
        var setUniqueIds;
        var arrayUniqueIds;

        if (statement.length > 0) {
            lastStatementBookGroups = statement[0].bookGroups;
            for (var i = 0; i < lastStatementBookGroups.length; i++) {
                if (lastStatementBookGroups[i].books.length > 0) {
                    if (this.tooltipCreate_DELIVERED(lastStatementBookGroups[i].books[0].book)) {
                        arrayOfBookIds.push(lastStatementBookGroups[i].books[0].book.id);
                    }
                }
            }
            setUniqueIds = new Set(arrayOfBookIds);
            arrayUniqueIds = [...setUniqueIds];
            if (arrayUniqueIds.length >= 2) {
                return true
            } else {
                arrayOfBookIds = [];

                for (var j = 0; j < statement.length; j++) {
                    for (var z = 0; z < statement[j].bookGroups.length; z++) {
                        if (statement[j].bookGroups[z].books.length > 0) {
                            if (this.tooltipCreate_DELIVERED(statement[j].bookGroups[z].books[0].book)) {
                                arrayOfBookIds.push(statement[j].bookGroups[z].books[0].book.id);
                            }
                        }
                    }
                }
                setUniqueIds = new Set(arrayOfBookIds);
                arrayUniqueIds = [...setUniqueIds];
                if (arrayUniqueIds.length >= 5) {
                    return true
                }
            }
        } else {
            return false
        }
    },

    formatDate(date) {
        var onlyDate = date.split(' ');
        var [day, month, year] = onlyDate[0].split('/');
        return Date.parse(`${month}/${day}/${year}`);
    },
// check if book is deliverd and if is true disable radio button
    checkIfBookIsDelivered(semesteItem, index) {
        var bookGroups = store.getters.active.bookGroups;
        var tooltipBookId = store.getters.tooltipBookId;
        var startDate = this.formatDate(store.getters.login.statementDataEntryValidDate.startDate);
        var endDate = this.formatDate(store.getters.login.statementDataEntryValidDate.endDate);

        //if index is -1 then is from checkbox
        if (index == -1) {
            for (var i = 0; i < semesteItem.courseBooks.length; i++) {
                var bookId = semesteItem.courseBooks[i].books[0].book.id;

                //check if book has tooltip
                if (tooltipBookId.hasOwnProperty(bookId)) {

                    //if book has tooltip check if is delivered
                    if (this.tooltipCreate_DELIVERED_FALSE(tooltipBookId[bookId].book) || this.tooltipGotVoucherOrPicked_up(tooltipBookId[bookId].book)) {
                        for (var j = 0; j < bookGroups.length; j++) {
                            if (bookGroups[j].books.length > 0) {
                                if (bookGroups[0].books[0]) {
                                    if ((bookGroups[j].books[0].book.id == bookId)
                                        && (startDate <= this.formatDate(tooltipBookId[bookId].date))
                                        && (this.formatDate(tooltipBookId[bookId].date) <= endDate)
                                        && (bookGroups[j].course.code == semesteItem.courseIno.code)
                                        && (bookGroups[j].statementBookGroupType != "CREDIT")) {
                                        return true;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return false;
        }

        // check if specific book is exist (from radio button)
        else if (semesteItem.courseBooks[index] != undefined) {
            var specificBook = semesteItem.courseBooks[index].books[0].book;

            for (var i = 0; i < semesteItem.courseBooks.length; i++) {
                var bookId = semesteItem.courseBooks[i].books[0].book.id;

                //check if book has tooltip
                if (tooltipBookId.hasOwnProperty(bookId)) {
                    if (this.tooltipCreate_DELIVERED_FALSE(tooltipBookId[bookId].book) || this.tooltipGotVoucherOrPicked_up(tooltipBookId[bookId].book)) {

                        //book is not from credit
                        for (var j = 0; j < bookGroups.length; j++) {
                            if (bookGroups[j].statementBookGroupType != "CREDIT") {
                                if ((bookGroups[j].books[0].book.id == bookId)
                                    && (startDate <= this.formatDate(tooltipBookId[bookId].date))
                                    && (this.formatDate(tooltipBookId[bookId].date) <= endDate)
                                    && (bookGroups[j].course.code == semesteItem.courseIno.code)) {
                                    return true;
                                }
                            } else {
                                if (tooltipBookId.hasOwnProperty(specificBook.id)) {
                                    if (bookGroups[j].books.length > 0) {
                                        if ((bookGroups[j].books[0].book.id == specificBook.id)
                                            && (startDate <= this.formatDate(tooltipBookId[specificBook.id].date))
                                            && (this.formatDate(tooltipBookId[specificBook.id].date) <= endDate)
                                            && (bookGroups[j].course.code == semesteItem.courseIno.code)) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return false;
        }
    },

    createStatementBookGroup() {
        var active = store.getters.active;
        var checkedBooks = store.getters.checkedBooks;
        var redeemPoints = store.getters.redeemPoints;
        console.log('@statement-start');
        console.log(checkedBooks);
        console.log(redeemPoints);
        active.bookGroups = [];
        for (let checkedBook in checkedBooks) {
            //delete priceCombination key from object checkedBooks
            if (checkedBooks[checkedBook].books.books[0].book.hasOwnProperty('priceCombination')) {
                delete checkedBooks[checkedBook].books.books[0].book.priceCombination;
            }
            active.bookGroups.push(checkedBooks[checkedBook].books);
        }
        for (let redeemPoint in redeemPoints) {
            //delete priceCombination key from object redeemPoints
            if (redeemPoints[redeemPoint].books.books[0].book.hasOwnProperty('priceCombination')) {
                delete redeemPoints[redeemPoint].books.books[0].book.priceCombination;
            }
            active.bookGroups.push(redeemPoints[redeemPoint].books);
        }
        if (active.hasOwnProperty("courrierId")) {
            delete active["courrierId"];
        }
        if (store.getters.courierInfoFlag === true
            && store.getters.courier.stationId != null) {
            active.courrierId = store.getters.courier.stationId
        }
        console.log('@statement-end');
        console.log(active);
        return active
    },

    // check if book is active from secretay
    checkIfBookIsActiveFromSecretary(allBooks) {

        var books = [];

        for (var i = 0; i < allBooks.length; i++) {
            if (allBooks[i].active === true) {
                books.push(allBooks[i]);
            }
        }
        var priceCompinationBooks = this.createPriceCombination(books);
        return priceCompinationBooks;
    },

//    add price combination key in book object
//    create help key in object to sort tables
    createPriceCombination(allBooks) {

        for (var i = 0; i < allBooks.length; i++) {
            if (allBooks[i].books[0].book.price) {
                allBooks[i].books[0].book.priceCombination = allBooks[i].books[0].book.price
            } else {
                allBooks[i].books[0].book.priceCombination = allBooks[i].books[0].book.suggestedPrice;
            }
        }
        return allBooks

    },

//    check when ExchangeTypeComponent is visible
    checkExchangeTypeComponentVisibility(statement) {

        var active = store.getters.active;

        if (active.id == statement.id) {

            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            var yyyy = today.getFullYear();

            today = mm + '/' + dd + '/' + yyyy;

            for (var statementDataEntryValidDate in store.getters.login.distributionDataEntryValidDates) {
                if (store.getters.login.distributionDataEntryValidDates[statementDataEntryValidDate].resourceType === 'Book_Delivery') {
                    var deliveryBookEndDate = this.formatDate(store.getters.login.distributionDataEntryValidDates[statementDataEntryValidDate].endDate);
                }
            }

            if (Date.parse(today) <= deliveryBookEndDate) {
                store.commit("setExchangeTypeComponentFlag", true)
            }
            else {
                store.commit("setExchangeTypeComponentFlag", false)
            }
        }
        else {
            store.commit("setExchangeTypeComponentFlag", false)
        }
    },
    
    // # # # VALIDATION # # #
    
    requiredRuleTextbox (v) {
        if (v && typeof v === 'string' && v.trim() !== '') {
            return true;
        } else {
            return 'Το πεδίο είναι υποχρεωτικό';
        }
    },
    
    selectboxRequired(obj) {
        if (obj.hasOwnProperty('id') && obj.id != null) {
            return true;
        } else {
            return 'Το πεδίο είναι υποχρεωτικό';
        }
    },
    phoneRulesRequired(v) {
        if (!v || v.trim().length === 0) {
            return 'Το πεδίο είναι υποχρεωτικό';
        }else{
            return true;
        }
    },
    
    phoneRules(v) {
        if (v && v.length > 0 && !/^[0-9]{8,13}$/.test(v))
            return 'Το πεδίο δεν είναι έγκυρο';
        return true;
    },
    
    emailRules(v) {
        if (v && v.length > 0) {
            if (/[Α-Ωα-ωίϊΐόάέύϋΰήώ]/.test(v))
                return 'Το e-mail δεν πρέπει να περιέχει ελληνικούς χαρακτήρες';
            if (v.includes(' '))
                return 'Το e-mail πρέπει να είναι έγκυρο';
            if (v.length > 127)
                return 'Το e-mail είναι πολύ μεγάλο';
            if (!/[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+/.test(v))
                return 'Το e-mail πρέπει να είναι έγκυρο';
        }
        return true;
    },

    removeDatatableLoadingElement() {
        // Required for compliance with WCAG 2.1 (StudentApp2 FrontEnd#51) because vue creates an empty <th> for the loading bar, which violates .
        // This is a dirty solution, but I couldn't find another way.
        let loadingElements = document.getElementsByClassName('v-datatable__progress');
        for (let i = loadingElements.length-1; i >= 0; i--)
            document.getElementsByClassName('v-datatable__progress')[i].remove();
    }
};

export default Utils
